import * as React from "react";
const SvgTexture = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M15.84 4L4 15.84V19.6133L19.6133 4H15.84ZM26.0133 4.10667L4.10667 26.0133C4.22667 26.4667 4.46667 26.88 4.78667 27.2133C5.12 27.5333 5.53333 27.7733 5.98667 27.8933L27.9067 5.98667C27.6533 5.06667 26.9333 4.34667 26.0133 4.10667ZM4 6.66667C4 5.2 5.2 4 6.66667 4H9.33333L4 9.33333V6.66667ZM25.3333 28C26.0667 28 26.7333 27.7067 27.2133 27.2133C27.7067 26.7333 28 26.0667 28 25.3333V22.6667L22.6667 28H25.3333ZM16.16 28H12.3867L28 12.3867V16.16L16.16 28Z",
	fill: "currentColor"
}));
export default SvgTexture;
